/*
 * @Author: 熊刚
 */
import Http from "./../http";
export default {
   localUrl:' ',
    // 获取月龄
    getkqMonthAge(params, callback){
        Http.get("/kqBack/findMonthAge",params, res => {
            callback(res);
          })
    },
    //获取所有分类标签
    getkqChildTag(params, callback){
        Http.get("/kqChildcare/getTags",params, res => {
            callback(res);
        },null, 'lucky')
    },
    //获取最新音频
    getNewAudio(urlParams, params, callback){
      Http.post( "/kqChildcare/pageKqAudioByTime", urlParams, params, res => {
        callback(res);
      }, err => { }, 'lucky')
    },
    
    // 获取音频列表
    getkqAudioList(urlParams, params, callback) {
        Http.post("/kqChildcare/kqAudioList", urlParams, params, res => {
          callback(res);
        }, null, 'lucky')
      },
       // 获取音频详情
       getAudioDetail(urlParams, params, callback) {
        Http.post("/kqChildcare/kqAudio", urlParams, params, res => {
          callback(res);
        }, null, 'lucky')
      },
       // 获取音频列表
    getkqDoctorAudioDetail(urlParams, params, callback) {
        Http.post("/kqChildcare/getAudioByExpert", urlParams, params, res => {
          callback(res);
        }, null, 'lucky')
      },
    //  获取所有医生
    getkqAllExpert(urlParams, params, callback) {
        Http.post("/kqChildcare/getAllExpert", urlParams, params, res => {
          callback(res);
        }, null, 'lucky')
      },
    //点赞
    addLike(params, callback){
        Http.get("/kqChildcare/addLike",params, res => {
            callback(res);
          }, null, 'lucky')
    },
    // 取消点赞
    cancleLike(params, callback){
        Http.get("/kqChildcare/cancelLike",params, res => {
            callback(res);
          }, null, 'lucky')
    },
    // 收藏
    addCollect(params, callback){
        Http.get("/kqChildcare/addCollect",params, res => {
            callback(res);
          }, null, 'lucky')
    },
    // 取消收藏
    cancelCollect(params, callback){
        Http.get("/kqChildcare/cancelCollect",params, res => {
            callback(res);
          }, null, 'lucky')
    },
    // 添加播放量
    addPlayNum(params, callback){
        Http.get("/kqChildcare/addPlayNum",params, res => {
            callback(res);
          }, null, 'lucky')
    },
   
      
}